import { EXPORT_METHODS } from '@/components/DataIngestion/_constants/data-ingestion';
import { Button, FieldError, SelectInput } from '@payloadcms/ui';
import { useState } from 'react';

interface ExportMethodSelectorProps {
  setValidExportMethod: (exportMethod: string) => void;
}

const ExportMethodSelector = ({ setValidExportMethod }: ExportMethodSelectorProps) => {
  const [exportMethod, setExportMethod] = useState<string>('');
  const [exportSourceError, setExportSourceError] = useState<boolean>(false);

  const EXPORT_METHOD_OPTIONS = [
    {
      label: 'Google Sheets',
      value: EXPORT_METHODS.GOOGLE_SHEET,
    },
  ];

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    e.stopPropagation();

    if (!exportMethod) {
      setExportSourceError(true);
      return;
    }

    setExportSourceError(false);
    setValidExportMethod(exportMethod);
  };

  return (
    <div>
      <h2>Choose an export method</h2>
      <form onSubmit={handleSubmit}>
        <SelectInput
          name="exportMethod"
          value={exportMethod}
          path="exportMethod"
          onChange={(options) => {
            if (options && 'value' in options) {
              setExportMethod(options.value as string);
            }
          }}
          label="Export method"
          description="Where would you like to export the data?"
          options={EXPORT_METHOD_OPTIONS}
          required={true}
          Error={<FieldError path="exportMethod" message="Export method is required" showError={exportSourceError} />}
        />
        <Button type="submit" buttonStyle="primary">
          Continue
        </Button>
      </form>
    </div>
  );
};

export default ExportMethodSelector;
